
/**
 * 프로젝트 메타 정보
 */
export interface ProjectMetaInfo {
  tags?: string[];
}
